@if (isVisible()) {
<app-dropdown
  label="Account"
  placeholder="No account selected"
  [triggerValue]="selectedAccount()?.name ?? null"
  [items]="accounts()"
  [itemId]="getAccountId"
  [selectedId]="selectedAccount()?.billingCrmAccountId ?? null"
  [isLoading]="isLoading()"
  [loadError]="loadError()"
  loadErrorMessage="Failed to load accounts"
  emptyMessage="No accounts available"
  [disabled]="isDisabled()"
  [isSaving]="isSaving()"
  [saveError]="saveError()"
  saveErrorMessage="Failed to switch account. Please try again."
  (opened)="onDropdownOpened()"
  (itemSelected)="selectAccount($event)"
  [itemTemplate]="accountItemTpl"
/>
}

<ng-template #accountItemTpl let-item>
  @let account = toAccountItem(item);
  <span class="account-option-name">{{ account.name }}</span>
  <span class="account-option-id">{{ account.id }}</span>
</ng-template>
